import React, {Component} from "react";
import classNames from "classnames";
import {Col, Container, Form, InputGroup, Nav, Row, Tab} from "react-bootstrap";
import InputSearch from "../forms/InputSearch";
import Tools from "../../../Tools";
import ShadowScrollbars from "../custom_scrollbars/ShadowScrollbars";
import TabsBase from "./TabsBase";


import '../../../assets/sass/global/tabs/vertical-tab.scss';
import InlineSVG from "react-inlinesvg";
import searchIcon from "../../../assets/svg/actions/icn-search.svg";

/**
 * VerticalTabsItem
 * @abstract
 */
class VerticalTabsItem extends Component {
    render = () => {
        return this.renderContent();
    };
}

/**
 * NOTE: It should be find a name that better expresses the component, I didn't think much when I chose this name ;)
 * No problem, We can change it in any time :)
 */

/**
 * VerticalTabs component.
 */
class VerticalTabs extends TabsBase {
    constructor(props) {
        super(props);

        this.state = {
            search: '',
        };
    }


    /**
     * Renders content of VerticalTabs component.
     * @returns {React.ReactNode} The VerticalTabs content.
     */
    renderContent = () => {
        const id = this.customId();
        const defaultKey = this.defaultKey();

        return (
            <Tab.Container id={id} defaultActiveKey={defaultKey}>
                <Container fluid={true}>
                    <Row className="h-100">
                        <Col lg={3} xs={6} className="p-0">
                            {this.renderTabsController()}
                        </Col>
                        <Col lg={9} xs={6} className="p-0">
                            {this.renderTabContent()}
                        </Col>
                    </Row>
                </Container>
            </Tab.Container>
        );
    };

    /**
     * Renders External JSX Component.
     * @returns {React.ReactNode} External JSX Component.
     */
    renderTopExtraTabsController = (items) => {

        var {renderExtraTabsController} = this.props;

        if(renderExtraTabsController && renderExtraTabsController.topComponent)
            return renderExtraTabsController.topComponent();
    }

    /**
     * Renders items of VerticalTabs controller.
     * @returns {React.ReactNode} The tab controller items.
     */
    renderTabsController = () => {
        const items = this.filteredItems();
        var {searchPlaceholder} = this.props;
        return (
            <div className="tabs-controller">
                {this.renderTopExtraTabsController(items)}

                {/*<InputSearch size="lg" type="primary" placeHolder={searchPlaceholder ?? "Search Scout Name"} onChange={this.handleSearch}/>*/}
                {/*todo-adel: this must be replace with InputSearch after fixed*/}

                {/*search has padding please loop to scouting scss and update it*/}
                <div className="search">
                    <InputGroup className="input-group-white-lg">
                        <Form.Control name="text" placeholder={ searchPlaceholder ?? "Search Scout Name" } className="input input-white input-lg" onChange={this.handleSearch} />
                        <InputGroup.Append>
                            <InputGroup.Text>
                                <i><InlineSVG src={searchIcon}/></i>
                            </InputGroup.Text>
                        </InputGroup.Append>
                    </InputGroup>
                </div>

                {
                    <ShadowScrollbars direction="left">
                        <Nav variant="pills" className="flex-column items">
                            {items.map((item, index) =>
                                <Nav.Link key={index} as="div" className="item" eventKey={item.key}> {item.header} </Nav.Link>)}
                        </Nav>
                    </ShadowScrollbars>
                }
            </div>
        );
    };


    /**
     * Wraps the content within scrollbar.
     * @param content {React.ReactNode} The content witch renders within scrollbar.
     * @returns {React.ReactNode} The wrapped component.
     */
    wrapWithinScrollbar = (content) => ShadowScrollbars.wrap(content);


    /**
     * Renders tabs panes.
     * @returns {React.ReactNode} The tab panes.
     */
    renderTabContent = () => {
        const items = this.items();

        return (
            <Tab.Content> {items.map(item => <Tab.Pane key={item.key} eventKey={item.key}> {item.content} </Tab.Pane>)} </Tab.Content>
        );
    };

    /**
     * Filters items list.
     * @param event {object} The change event.
     */
    handleSearch = (event) => {
        const value = event.target.value;

        this.setState({
            search: value,
        });
    };

    /**
     * Returns the filtered items of tab controller.
     * @returns {React.ReactNode} The filtered tab controller items.
     */
    filteredItems = () => {
        return this.items().filter(item => Tools.findInArray(item.searchableFields, this.state.search));
    };

    /**
     * Returns the custom classes of vertical tab component.
     * @returns {React.ReactNode} The custom classes.
     */
    customClasses = () => 'vertical-tab';
}

VerticalTabs.Item = VerticalTabsItem;
export default VerticalTabs;
